export default {
    doctorAttFile: "Læge-FP710.pdf",
    login_header:
        "Velkommen til WTW´s Forsikrings - og skadesportal",
    login_text:
        "Her kan du anmelde en skade eller tilføje dokumenter til en igangværende skade. Du kan også se de forsikringer du har via Entercard på dit kreditkort eller lån.",
    login_button: "Log på med MitID",
    footer_contactus: "Kontakt os",
    footer_aboutus: "Om os",
    footer_complaints: "Klage",
    menu_home: "HJEM",
    menu_myins: "MINE FORSIKRINGER",
    menu_claim: "ANMELD SKADE",
    menu_updateclaim: "VIS SAG/TILFØJ DOKUMENTATION",
    menu_qa: "SPØRGSMÅL OG SVAR",
    home_name: "Navn",
    home_ssn: "Personnummer",
    home_email: "E-post",
    home_welcomeheader: "Velkommen til Willis Towers Watson (WTW).",
    home_welcometext: "Her kan du nemt anmelde en skade på din låne -og betalingsforsikring som du har tegnet via Entercard. Willis Towers Watson Sweden AB(WTW) administrerer og afgør krav på vegne av forsikringsselskabet AmTrust.",
    myins_ins: "Forsikring",
    myins_card: "Kort/Lån",
    myins_fromdate: "Fra dato",
    myins_todate: "Til dato",
    myins_infotext: "Her ser du de forsikringer du har tegnet på dit kort og/eller lån du har hos Entercard.",
    claim_info1_1: "Her anmelder du din skade ved at udfylde de oplysninger vi skal bruge for at kunne afgøre om du er beretttiget til erstatning.",
    claim_info1_2: "Du bekræfter, at du giver korrekte og fuldstændige oplysninger ved at underskrive din anmeldelse.",
    claim_info1_3: "Du kan løbende tilføje dokumenter til din skade under vis/afslut igangværende sag",
    claim_info2_1: "Det er vigtig, at alle felter relateret til din skade er udfyldt korrekt, idet din underskrevne skadeanmeldelse også bruges som fuldmagt til indhentning af f.eks. journaler eller andre oplysninger som forsikringsselskabet anser for nødvendige for at vurdere dit erstatningskrav.",
    claim_info2_2: "Det skal tydeligt fremgå, hvad du søger erstatning for. Ved sygdom/uheld skal symptomer på sygdom eller diagnose fremgå tydeligt i skadeanmeldelsen.",
    claim_event: "Skadetype",
    claim_date: "Skadedag",
    claim_button: "Anmeld",
    claim_unemployment: "Arbejdsløshed",
    claim_sick: "Sygemelding",
    claim_hospital: "Hospitalsindlæggelse",
    claim_unemployment_info: " (Gælder ikke selvstændig erhvervsdrivende) ",
    claim_unemployment_info2: "Skadedagen er den dag du fik kendskab til opsigelsen/varsel om opsigelse",
    claim_sick_info: "(Midlertidig uarbejdsdygtig) ",
    claim_sick_info2: "Skadedagen er første dag på sygemeldingen.",
    claim_hospital_info: "(Gælder kun for selvstændig erhvervsdrivende) ",
    claim_hospital_info2: "Skadedagen er den dagen du ble innlagt på sygehus.",
    dateformat: "dd-MM-yyyy",
    stepper_step1: "Personoplysninger",
    stepper_step2_unemployment: "Arbejde",
    stepper_step2_sick: "Sygemelding",
    stepper_step2_hospital: "Hospitalsindlæggelse",
    stepper_step3: "Underskriv",
    step1_names: "Fornavn Efternavn",
    stepper_next: "NÆSTE",
    stepper_back: "TILBAGE",
    unemp_employstart: "Ansættelses dato",
    unemp_workfulltime: "Arbejdede du fuldtid?",
    yes: "Ja",
    no: "Nej",
    unemp_hoursperweek: "Antal timer/uge",
    unemp_notice: "Hvornår blev du bekendt med opsigelsen/opsigelsesvarsel?",
    unemp_terminated: "Dato på ansættelses ophør",
    unemp_reason: "Årsag til opsigelse",
    unemp_worktype: "Ansættelsesform(fuldtid, deltid, vikar el.lign.)",
    unemp_enrolled: "Er/var du registreret hos Jobcentret som ledig i perioden du var/er ledig?",
    unemp_selfemployed: "Driver du egen virksomhed?",
    unemp_file_empcert: "- Job kontrakt",
    unemp_file_terminationcert: "- Dokumenter, der bekræfter opsigelsen indeholdt dato og årsag til opsigelsen.",
    unemp_file_payments: "- Alle udbetalinger fra Jobcentret.",
    unemp_file_unempcert: "- Afgørelse om dagpenge fra Jobcentret.",
    file_button: "VÆLG FIL",
    file_attatchmentsInfo: "Dokumenter der skal uploades",
    file_attachmentsInfo2: "For hurtig og korrekt ekspedition bedes du indsende alle dokumenter for hele den periode du søger erstatning for. Du kan uploade flere dokumenter på samme tid. Ved forlængelse tilføjer du yderligere dokumentation i 30 sammenhængende dage.",
    select_error: "Du må angi et valg",
    file_tooltip1: "Vi godtager følgende filformat: PDF, JPG, JPEG, PNG, IMG, TIFF, BMP.",
    file_tooltip2: "Vil du sende i et andet filformat kan du sende til: okonomisikring@wtwco.com",
    file_tooltip3: "Det er også muligt at uploade fotos eller skærmbillede af dokumenterne. Bemærk venligst, at teksten skal være klar og tydelig.",

    sick_type: "Velg skade",
    sick_accident: "Ulykke",
    sick_sick: "Sygdom",
    sick_accidentdate: "Hvornår skete ulykken?",
    sick_accidentlocation: "Hvor skete ulykken?",
    sick_firstsickdate: "Første sygemeldingsdag",
    sick_lastsickdate: "Sidste sygemeldingsdag, hvis du ikke længere er sygemeldt",
    sick_accidenthow: "Hvordan skete ulykken?",
    sick_sickwhen: "Hvornår opstod sygdommen? ",
    sick_symptoms: "Sygdommens symptomer/diagnose",
    sick_firstdaydoctor: "Hvornår opsøgte du læge for første gang?",
    sick_doctornameadress: "Lægens nanv og adresse. Evt. mail adresse",
    sick_file_sickcert: "- Alle sygemeldinger med diagnose",
    sick_file_workcert: "- Jobkontrakt der bekræfter nuværende ansættelse",
    sick_file_doctorcert: "- Legeerklæring ifyllt av din fastlege/primærlege. (Du finner denne lengre ned på siden)",
    sick_file_journal: "- Journal fra hospitalet eller andet sundhedsvæsen (hvis du har)",
    sick_file_socialsecurity: "- Arbejdsgiver betaler løn under sygdom men kan efter nogle uger få refusion fra kommunen.",
    sick_doctorsatt_info: "For hurtigere ekspedition bedes du udskrive lægeerklæringen som din læge skal udfylde. Du kan derefter fotografere lægeerklæringen og uploade den eller sende den via e-mail. Bemærk venligst, at teksten skal være klar og tydelig. Hvis du ikke har en printer kan du sende en mail til: okonomisikring@wtwco.com, så sender vi lægeerklæringen til dig.",
    sick_doctorslink: "Download lægeerklæring",

    hospital_type: "Velg skade",
    hospital_accident: "Ulykke",
    hospital_sick: "Sygdom",
    hospital_accidentdate: "Hvornår skete ulykken?",
    hospital_accidentlocation: "Hvor skete ulykken?",
    hospital_firstday: "Første indlæggelsesdag på hospitalet?",
    hospital_lastday: "Sidste indlæggelsesdag på hospitalet?",
    hospital_accidenthow: "Hvordan skete ulykken?",
    hospital_sickhow: "Hvornår opstod sygdommen?",
    hospital_symptoms: "Sygdommens symptomer/diagnose",
    hospital_doctordate: "Hvornår opsøgte du læge for første gang?",
    hospital_doctorname: "Lægens nanv og adresse. Evt. mail adresse",
    hospital_file_doctorcert: "- Arbejdsgiver betaler løn under sygdom men kan efter nogle uger få refusion fra kommunen.",
    hospital_file_journals: "- Journal fra hospitalet eller andet sundhedsvæsen",
    hospital_emptyoptional: "Lad feltet stå tomt, hvis du ikke har oplysningen",

    gdpr_header1: "Personoplysninger",
    gdpr_header2: "Samtykke vedrørerende behandling af personfølsomme oplysninger",
    gdpr_text: "De personoplysninger, der gives til forsikringsselskabet AmTrust International Underwriters DAC (“AmTrust”) behandles i overensstemmelse med gældende databeskyttelseslovgivning og virksomhedens retningslinjer. AmTrust er persondataansvarlig for sin behandling af dine persondata og information om hvordan persondata behandles i AmTrust er tilgængelig på www.amtrustnordic.se. Willis Towers Watson Sweden AB (“WTW”) udfører skadebehandling på vegne af AmTrust. Som skadebehandler behandler WTW dine personoplysninger som persondatabehandler for AmTrust.",
    gdpr_approve1: "Godkendelse behandling af personoplysninger",
    gdpr_approve2: "Godkender at mine oplysninger er fuldstændige og korrekte",
    button_sign: "UNDERSKRIV",
    spinner_loading: "Henter data",
    spinner_signing: "Gemmer din anmeldelse",

    confirmation_header1: "Din anmeldelse er nu sendt til din e-mail.",
    confirmation_text0: "Din skadeanmeldelse med sagsnummer #refnr# er nu gemt i vores skadesystem. ",
    confirmation_text1: "Du bedes underskrive din anmeldelse digitalt. Du vil snart modtage en e-mail fra Willis Towers Watson (WTW) via Assently med vejledning på, hvordan du underskriver. Tjek også din spammail/uønsket mail, hvis du ikke finder mailen i din indbakke.",
    confirmation_text2: "Vi kan først behandle din sag, når du har skrevet under.",
    confirmation_text3: "Hvis du ikke har skrevet under senest den #lastsigndate#, vil din sag blive lukket.",
    confirmation_text4: "Vær opmærksom på, at din forsikringssag først er gennemført, når den er underskrevet af dig. For at vi kan starte behandlingen, er det derfor vigtigt, at du skriver under så hurtigt som muligt.",
    confirmation_text5: "Du vil modtage en bekræftelse i din e-mail, når du har underskrevet din anmeldelse.",
    button_backtomain: "Tilbage til startsiden",

    update_header: "Dine forsikringssager",
    update_noclaim: "Der er ingen sager at vise",
    update_text: "Klik på sagen for at se status. Hvis du har flere kort eller lån, som påvirkes, vises status for alle disse.",
    update_label_claimcase: "Forsikringssag",
    update_label_claimetype: "Skadetype",
    update_label_reported: "Anmeld",
    update_label_status: "Status",
    update_label_cardloan: "Kort/Lån",
    update_claimlabel: "Forsikringssag ",
    update_thanks: "Takk for at du har lagt til dokumentasjon i din forsikringssak.",
    update_error: "Det har oppstått en teknisk feil. Vennligst kontakt Willis Towers Watson Sweden AB (WTW) Epost: okonomisikring@wtwco.com Telefon: 24 12 63 07",
    button_send: "INDSEND",

    qa_header: "Spørgsmål og svar lån- og betalingsforsikring.",
    qa_q1_header: "Jeg har tegnet forsikring via Entercard. Hvad er Willis Towers Watsons rolle?",
    qa_q1_answer: "Willis Towers Watson administrerer forsikringen samt håndterer skader på vegne af forsikringsselskabet Amtrust, for de kunder hos Entercard, der har tegnet en Økonimisikring",
    qa_q2_header: "Er Willis Towers Watson (WTW) et forsikringsselskab?",
    qa_q2_answer: "Nej, Willis Towers Watson er en forsikringsmægler under tilsyn af det svenske finanstilsyn. Udover at hjælpe store virksomheder med at finde forsikringsløsninger, arbejder vi også med skadeopgørelse, hvilket er tilfældet i samarbejdet med Entercard. AmTrust er forsikringsselskabet og deres rolle er bl.a, i tilfælde af erstatningsberettiget skade, at betale erstatning. I dette tilfælde betyder det, at gælden eller lånet på kreditkortet hos Entercard er forsikret.",
    qa_q3_header: "Hvordan kan jeg føle mig sikker på, at de oplysninger jeg giver vil blive behandlet fortroligt?",
    qa_q3_answer: "Hos Willis Towers Watson behandler vi alle oplysninger, data og dokumenter fra kunder fortroligt. Vi har begrænset adgang til de oplysninger du giver, og bruger tekniske og fysiske sikkerhedsforanstaltninger til at beskytte dine oplysninger med, af hensyn til sikkerhed, fortrolighed og privatliv.",
    qa_q4_header: "Hvordan håndteres mine personoplysninger efter jeg har anmeldt en skade?",
    qa_q4_answer: "Vi håndterer alle dine personopplysninger i henhold til GDPR, som bl.a. betyder, at vi kun opbevarer de oplysninger vi skal bruge for at kunne håndtere din forsikringssag. For at læse mere om vores behandling af personoplysninger, klik",
    qa_q4_here: "her",
    qa_q5_header: "Hvordan fremskynder jeg behandlingen af min forsikringssag?",
    qa_q5_answer: "For at vi på en hurtig og korrekt måde kan afgøre, om du er berettiget til erstatning, bedes du udfylde alle de oplysninger vi beder om og samtidig sikre, at vi modtager alle de dokumenter, der er nødvendige for, at vi kan træffe afgørelse i sagen. Du fremlægger dokumentation for hele den periode, du søger erstatning for. Ved forlængelse indsender du yderligere dokumentation inden for 30 dage, så vi hurtigere kan behandle din sag for yderligere erstatning.",
    qa_q6_header: "Hvad sker der, hvis jeg ikke indsender fuldstændige og korrekte oplysninger, som I skal bruge for at kunne tage stilling til sagen?",
    qa_q6_answer: "Jo mere fyldestgørende og korrekt information fra dig, desto hurtigere kan vi behandle skaden. Mangler vi oplysninger for at kunne træffe en beslutning, vil vi kontakte dig via e-mail.",
    qa_q7_header: "Hvad gør jeg hvis jeg har brug for at indsende flere dokumenter tlil en sag?",
    qa_q7_answer: "Du kan løbende uploade nye dokumenter til din forsikringssag under Se sag / tilføj dokumentation. Ved løbende at indsende yderligere dokumentation i 30 sammenhængende dage kan vi hurtigere behandle sagen yderligere.",
    qa_q8_header: "Hvorfor spørger i min læge om tidligere sygdomme?",
    qa_q8_answer: "Det er vigtigt for os, at vide hvornår din sygdom opstod for at kunne afgøre om du har krav på erstatning. At du tidligere har haft symptomer på en sygdom, som måske først kan diagnosticeres senere.",
    qa_q9_header: "Hvad gør jeg hvis lægen ikke udfylder en lægeerklæring, eller det tager lang tid?",
    qa_q9_answer1: "Det nemmeste er, hvis du i forbindelse med et lægebesøg, har printet lægeerklæringen ud og beder lægen udfylde de oplysninger vi beder om. Det er vigtigt, at lægens navn og klinik fremgår, og at lægen attesterer, at oplysningerne i attesten er korrekte. Du kan finde lægeerklæringen ",
    qa_q9_answer2: "Hvis du ikke har adgang til en printer, kan du sende os en e-mail til okonomisikring@wtwco.com, så sender vi denne til dig.",
    qa_q10_header: "Hvorfor får jeg ikke erstatning for hele fakturabeløbet og for indeværende måned?",
    qa_q10_answer1: "Du får udbetalt erstatning fra dag 31 (skadedag efter den 01.11.2021)  og denne beregnes efter de dage, hvor du er sygemeldt eller arbejdsledig, hvilket betyder at i nogle måneder betales fakturaen ikke fuldt ud af din forsikring. Det afgørende er fx antal dage du har afleveret dokumentation på samt om din sag har været sat på hold. Forsikringen kan ikke yde erstatning for indeværende måned grundet den endnu ikke er blevet faktureret. Husk du er selv altid ansvarlig for, at betale faktura udsted fra Entercard men din ret til erstatning tilpasses altid løbende eftersom vi modtager dokumentation. Hvis du af en eller anden årsag har svært ved at betale din faktura, bedes du kontakte Entercard, mens du venter på at din erstatning bliver godkendt. Du finder kontaktinformation ",
    qa_q10_answer2: "https://www.entercard.dk/kontakt-dk/kundeservice/",
    qa_q11_header: "Hvordan udbetales erstatningen?",
    qa_q11_answer: "Erstatningen udbetales altid direkte til det kort/lån, der er forsikret. Du kan se kompensationen på mine sider, gældende kortet/lånet, et par hverdage efter vi har foretaget betalingen. Filoverførslen finder sted hver torsdag aften i måneder, der er gået. Du får derfor ikke udbetalt erstatning for den aktuelle måned.",
    qa_q12_header: "Jeg ser, at der er nye betingelser pr. 01-11-2021. Hvad er de største forskelle fra de gamle betingelser?",
    qa_q12_answer1: "•	Skader som sker efter 01.11.2021 skal reguleres efter de nye vilkår.",
    qa_q12_answer2: "• Karenstiden er herefter 30 dage fra skadedatoen for sygdom og ledighed, hvilket betyder, at erstatningen er fra dag 31. Du får ikke erstatning de første 30 dage.",
    qa_q12_answer3: "• Rekvalifikationsperioden vil sige den tid det tager før du er berettiget til ny erstatning. For samme type skade forkortes fra 12 til 6 måneder, hvis den tidligere skade er sket efter 01.11.2021.",
    qa_q13_header: "Hvor finder jeg forklaringer på alle de definitioner I henviser til?",
    qa_q13_answer1: "Definitionerne er forklaret bagerst i forsikringsvilkårene. Du finder dem på Entercards hjemmeside her:",
    qa_q13_answer2: "Betalingsforsikring",
    qa_q13_answer3: "http://www.entercard.no/terms-and-conditions-insurance/norway/vilkar-betalingsforsikring-plus",
    qa_q13_answer4: "Låneforsikring ",
    qa_q13_answer5: "http://www.entercard.no/terms-and-conditions-insurance/norway/vilkar-laneforsikring-plus",
    qa_q13_answer6: "",
    qa_q13_answer7: "",

    startpage_phonenr: "88 13 92 44",
    startpage_email: "okonomisikring@wtwco.com",

    application_confirmation1: "Der er opstået en teknisk fejl",
    application_confirmation2: "Venligst kontakt Willis Towers Watson",
    application_confirmation3: "Epost: okonomisikring@wtwco.com",
    application_confirmation4: "Telefon: 88 13 92 44",
    application_confirmation_back: "Tilbage",

    error_mandatory: "Obligatorisk",
    error_invalidentry: "Ugyldig data",
    error_invalidemail: "Ugyldig data mail adresse",
    error_invalidfileformat: "Ugyldigt filformat",

    ins_notfound1: "Der er ingen gyldig forsikring for den skadedato du har angivet.",
    ins_notfound2: "Hvis du har spørsmål angående din skadeanmeldelse, venligst kontakt Willis Towers Watson Sweden AB.",
    ins_notfound3: "Telefon: 88 13 92 44",

    footer_contact_header: "Kontakt os",
    footer_contact_closebtn: "Luk",
    footer_contact_tel: "88 13 92 44",
    footer_contact_email: "okonomisikring@wtwco.com",
    footer_contact1: "Åbningstider",
    footer_contact2: "Hverdage 09.00-16.00",
    footer_contact3: "Mailadresse",
    footer_contact4: "Att: Økonomisikring",
    footer_contact5: "WTW",
    footer_contact6: "Rundforbivej 303",
    footer_contact7: "2850 Nærum",

    menu_payments: "FORSIKRINGSYDELSER",
    menu_logout: "LOG UD",
    myins_docs_header: "Forsikringsdokumenter",
    myins_docs_showhide: "Vis/ skjul",
    myins_docs_show: "Vis dokumenter",
    myins_docs_hide: "Skjul dokumenter",
    myins_payment_table_region: "Forsikringsbetalinger",
    myins_docs_filename: "Filnavn",
    myins_docs_filetype: "Filtype",
    myins_docs_created: "Oprettet",
    myins_payment_infotext: "Nedenfor finder du dine forsikringer på kort/ lån, som du har tegnet via Entercard. Klik på det respektive kort/ lån for at se dine forsikringsydelser. Husk at der går et par bankdage, før Entercard når at registrere erstatningen på dit kort/ lån",
    myins_payment_header: "Forsikringsydelser",
    myins_payment_amount: "Beløb (kr)",
    myins_payment_fromdate: "Fr.o.m.",
    myins_payment_todate: "T.o.m.",
    myins_payment_days: "Dage",
    myins_payment_transdate: "Fil dato",
    myins_payment_type: "Type",
    sick_firstsickday: "Første sygemeldingsdag",
    sick_lastsickday: "Sidste sygemeldingsdag",
    hospital_firsthospitalday: "Første dag for indskrivning på hospitalet",
    hospital_lasthospitalday: "Sidste dag for indskrivning på hospitalet",
    hospital_doctornameadress: "Lægens navn og adresse. Evt. E-mail",

    presaledoc_showAll: "Se alle dokumenter",

    qanda_11_Header: "Vilkår og betingelser",
    qandatandcppifile: "TC_Entercard Plus_DK_PPI.pdf",
    qandatandclpifile: "TC_Entercard_DK_LPI.pdf",
    qandatandclpilofile: "",
    ppi: "Økonomisikring",
    lpi: "Låneforsikring",
    lpilo: ""


};